import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Search from "../Search";

const PartsFilter = (props) => {
  const labels = useSelector(state => ({
    partNumber: state.labels.partNumber,
    parts: state.labels.parts,
    placeholder: state.labels.filterParts,
  }));
  const count = useSelector(state => state.parts.count);
  const lastReset = useSelector(state => state.filters.lastReset);

  return (
    <Search
      name={labels.partNumber}
      parameter="0"
      placeholder={labels.placeholder}
      value={""}
    />
  );
};

PartsFilter.defaultProps = {
  count: 0,
};

PartsFilter.propTypes = {
  labels: PropTypes.shape({
    partNumber: PropTypes.string.isRequired,
    parts: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
  }),
};

export default PartsFilter;
